import { api } from '../plugins/axios';

export default class SharedService {
	static getEnumsList(list) {
		return api
			.get('/core/list/enum-list', {
				params: {
					list,
				},
			})
			.then((res) => res.data?.result?.lists);
	}
	static getCities(params) {
		return api
			.get('/core/cities-list', {
				params,
			})
			.then(({ data }) => ({
				data: data.result?.cities?.data || [],
				totalRecords: data.result?.cities?.total,
			}));
	}

	static getUsers(params) {
		return api
			.get('/users', {
				params,
			})
			.then(({ data }) => ({
				data: data.result?.users?.data || [],
				totalRecords: data.result?.users?.total,
			}));
	}

	static async exportData({ type, params }) {
		return api.get(`/export/${type}`, { params });
    }
	static uploadTempFile(formData) {
		return api
			.post('/core/upload-temp-file', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})
			.then((res) => res.data);
	}
}
